import { Button, Descriptions, Tag } from 'antd';
import styled from 'styled-components';
import { Enterprise, enterpriseType1Korean } from '../../modules/auth';
import { corporateNumberFormatter, phoneFormatter } from '../../util/utils';
import { styledDescriptions } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface MyEnterpriseDetailComponentProps {
  myEnterprise: Enterprise;
  moveToEnterpriseEditPage: () => void;
}

function MyEnterpriseDetailComponent({
  myEnterprise,
  moveToEnterpriseEditPage,
}: MyEnterpriseDetailComponentProps) {
  return (
    <StyledDiv>
      <Descriptions
        title="기본정보"
        bordered
        column={2}
        size="small"
        extra={<Button onClick={moveToEnterpriseEditPage}>수정</Button>}
      >
        <Descriptions.Item label="회사명">
          {myEnterprise.name}
        </Descriptions.Item>
        <Descriptions.Item label="대표명">
          {myEnterprise.representative}
        </Descriptions.Item>
        <Descriptions.Item label="사업자등록번호">
          {corporateNumberFormatter(myEnterprise.corporateNumber)}
        </Descriptions.Item>
        <Descriptions.Item label="주소" style={{ whiteSpace: 'pre-wrap' }}>
          {`${myEnterprise.address ? myEnterprise.address : ''}\n${
            myEnterprise.detailAddress ? myEnterprise.detailAddress : ''
          }`}
        </Descriptions.Item>
        <Descriptions.Item label="전화번호">
          {phoneFormatter(myEnterprise.corporatePhone, 1)}
        </Descriptions.Item>
        <Descriptions.Item label="공사종류">
          <span>
            {myEnterprise.type1 === null
              ? null
              : enterpriseType1Korean[myEnterprise.type1]}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="주력분야">
          <>
            {myEnterprise.workPerformed === null
              ? null
              : myEnterprise.workPerformed.map((tag: any, index: any) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
          </>
        </Descriptions.Item>
        <Descriptions.Item label="보유면허">
          <>
            {myEnterprise.type2 === null
              ? null
              : myEnterprise.type2.map((tag: any, index: any) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
          </>
        </Descriptions.Item>
        <Descriptions.Item label="공사가능지역">
          <>
            {myEnterprise.region === null
              ? null
              : myEnterprise.region.map((tag: any, index: any) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
          </>
        </Descriptions.Item>
      </Descriptions>
    </StyledDiv>
  );
}
export default MyEnterpriseDetailComponent;
